import type { MemoForChart } from "./memo-types";

export const DEFAULT_MEMO_COLOR = "#8b5cf6";
export const SYSTEM_MEMO_COLOR = "#f97316";

export const MEMO_COLOR_OPTIONS = [
  DEFAULT_MEMO_COLOR,
  "#dc2626",
  "#16a34a",
  "#0891b2",
  "#2563eb",
  "#92400e",
] as const;

/**
 * chart / tooltip で memo を表示する色を決めます。
 * system memo と user memo の fallback を一箇所に閉じ、surface 間の色 drift を防ぎます。
 */
export function memoDisplayColor(memo: MemoForChart) {
  if (memo.color) return memo.color;
  if (memo.memoType === "SYSTEM") {
    return SYSTEM_MEMO_COLOR;
  }
  return DEFAULT_MEMO_COLOR;
}
